// extracted by mini-css-extract-plugin
export default {"butBody":"rejectButton_butBody__SAHnq fontsStyles_smallText__nqlii"};